exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6b3cc2fe] .el-card__body{height:100%}.title[data-v-6b3cc2fe]{color:var(--textColor);position:relative}.title[data-v-6b3cc2fe]:before{position:absolute;content:\"\";width:2px;height:70%;left:-8px;top:4px;background-color:var(--systemColor)}.detail-height[data-v-6b3cc2fe]{height:calc(100% - 52px)}", ""]);

// exports
